import { PromptInputDisplayAttachmentChip } from "@rulebase/core/components";
import type { TicketContext } from "./ticket-context";

export function TicketContextChip({ context }: { context: TicketContext }) {
  return (
    <div className="flex flex-wrap gap-1 px-2 pt-2">
      <PromptInputDisplayAttachmentChip
        attachment={{
          id: context.conversationId,
          label: context.ticketLabel,
          type: "conversation",
        }}
        title={`Ticket ${context.ticketLabel} is in context`}
      />
    </div>
  );
}
